import React, { useEffect } from "react";

import { Card, CardContent, Stack, Typography } from "@mui/material";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { CorrelationMatrix } from "components/Investor-portfolio/Correlation-matrix/CorrelationMatrix";
import { useActionHook } from "hooks";
import { useCorrelationMatrixSettingsSelector, usePortfolioConstructionActions } from "store";

import { usePortfolioConstructionContext } from "../Context/PortfolioConstructionContext";

export const Correlation: React.FC = () => {
  const { selectedInvestorId, activeSliceType } = usePortfolioConstructionContext();
  const settings = useCorrelationMatrixSettingsSelector();
  const { getCorrelationDataAction } = usePortfolioConstructionActions();

  const {
    action: getCorrelationData,
    data: correlationData,
    loading: correlationLoading
  } = useActionHook(getCorrelationDataAction);

  const investorIdNum =
    activeSliceType === "investor" && selectedInvestorId !== null ? Number(selectedInvestorId) : null;

  useEffect(() => {
    if (investorIdNum === null) return;
    getCorrelationData({ investor_id: investorIdNum, ...settings });
  }, [investorIdNum, settings, getCorrelationData]);

  if (investorIdNum === null) {
    return (
      <Card sx={{ boxShadow: "0 1px 2px 0 #1212171a", borderRadius: "8px", minHeight: 300 }}>
        <CardContent sx={{ padding: "16px" }}>
          <Stack sx={{ alignItems: "center", justifyContent: "center", py: "60px" }}>
            <Typography variant="h6" sx={{ color: "#496682", mb: "10px" }}>
              Correlation Analysis
            </Typography>
            <Typography sx={{ color: "#5d7782", textAlign: "center", maxWidth: "400px" }}>
              Select an investor to view correlation data.
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    );
  }

  return (
    <Stack gap="20px">
      <Card sx={{ boxShadow: "0 1px 2px 0 #1212171a", borderRadius: "8px", minHeight: 300 }}>
        <AsyncContentMui isLoading={correlationLoading}>
          <CardContent sx={{ padding: "16px" }}>
            {correlationData ? (
              <CorrelationMatrix data={correlationData} investorId={investorIdNum} />
            ) : (
              <Stack sx={{ alignItems: "center", justifyContent: "center", py: "60px" }}>
                <Typography variant="h6" sx={{ color: "#496682", mb: "10px" }}>
                  Correlation Analysis
                </Typography>
                <Typography sx={{ color: "#5d7782", textAlign: "center", maxWidth: "400px" }}>
                  No correlation data available for this investor.
                </Typography>
              </Stack>
            )}
          </CardContent>
        </AsyncContentMui>
      </Card>
    </Stack>
  );
};
